
import { useEffect, useState } from 'react';

import groupBy from 'lodash/groupBy';

import { useDispatch, useSelector } from 'react-redux';
import { Tabs } from 'antd';
import { isEmpty } from 'lodash';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

import { MOBILE_MEDIA_POINT, Routes } from '@share/constants';
import { getQuotes, markQuotesAsRead } from '@share/store/slices';
import { RootState, getKeyQuotesFromPath, LoginType, isQuotesFromPath } from '@share/utils';
import { QuoteModalCompare, SearchTable } from '@components';
import { IColumnMenu, NULL_VALUE } from '@constants';
import { QuoteCarModalCompare } from '../quote-car-modal-compare';
import { QuoteCondosModalCompare } from '../quote-condos-modal-compare';
import { CARS_KEY, GetMyQuotesTabs, GetQuoteDatasourceData, HOTELS_KEY } from './utils';

import './style.scss';

export function MyQuotes() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const quoteStore = useSelector((state: RootState) => state.quoteStore);
  const navigationMenuStore = useSelector((state: RootState) => state.navigationMenuStore);
  
  const { items } = navigationMenuStore;
  const { account, user } = loginStore;
  const { loading, result } = quoteStore;

  const { quotesHotels, quotesCondos,quotesCars, quotesHistorical } = result;

  const [visibleHotels, setVisibleHotels] = useState(false);
  const [visibleCondos, setVisibleCondos] = useState(false);
  const [visibleCars, setVisibleCars] = useState(false);
  const [quoteBase, setQuoteBase] = useState<string | null>(null);
  
  const isMobile = document.body.offsetWidth <= MOBILE_MEDIA_POINT;
  
  const dispatch = useDispatch();

  const history = useHistory();

  if (!account || account.type === LoginType.Public) {
    history.push(Routes.NotAuthorized);
  }


  useEffect(() => {
    if (!loginStore.loading) {
      const param = getKeyQuotesFromPath();
      setQuoteBase(param);
      dispatch(getQuotes(param));

      const isQuotes = isQuotesFromPath(history);
      if (isQuotes && param) {
        dispatch(markQuotesAsRead(param));
      }
    }
  }, [loginStore.loading])

  useEffect(() => {
    if (!!quoteStore.result.selectedQuotes?.length) {
      const quoteType = quoteStore.result.selectedQuotes[0].quoteType;
      if (quoteType === 'Condo') {
        setVisibleCondos(true);
      } else if (quoteType === 'Hotel') {
        setVisibleHotels(true);
      } else if (quoteType === 'Car') {
        setVisibleCars(true);
      }
    }
  }, [quoteStore.result.selectedQuotes])

  const handleOnRefresh = () => {
    if (user) {
      dispatch(getQuotes());
    }
  };

  let dataSourceHotels = [];
  let dataSourceCondos = [];
  let dataSourceCars =[];
  let dataSourceHistorical = [];

  if (quotesHotels.length) {
    const grouped = groupBy(quotesHotels, quote => quote.quoteBaseId);
    dataSourceHotels = Object.entries(grouped).map(([_key, quote]) => GetQuoteDatasourceData(quote[0]));
  }

  if (quotesCondos.length) {
    const grouped = groupBy(quotesCondos, quote => quote.quoteBaseId);
    dataSourceCondos = Object.entries(grouped).map(([_key, quote]) => GetQuoteDatasourceData(quote[0], quotesCondos));
  }

  if (quotesCars.length) {
    const grouped = groupBy(quotesCars, quote => quote.quoteBaseId);
    dataSourceCars = Object.entries(grouped).map(([_key, quote]) => GetQuoteDatasourceData(quote[0], quotesCars));
  }

  if (quotesHistorical.length) {
    const grouped = groupBy(quotesHistorical, quote => quote.quoteBaseId);
    dataSourceHistorical = Object.entries(grouped).map(([_key, quote]) => GetQuoteDatasourceData(quote[0], quotesHistorical));
  }

  let tabs = GetMyQuotesTabs(isMobile, dataSourceHotels, dataSourceCondos, dataSourceCars, dataSourceHistorical, setVisibleHotels, setVisibleCondos, setVisibleCars, setQuoteBase, (quoteId) => {
    dispatch(markQuotesAsRead(quoteId));
  });
  
  const isCarsShareCompareEnabled = account?.carsShareCompareEnabled && 
                                        (!account?.isRSITemplate || ((!account?.carsShareCompareRsiSiteidList?.length && !account?.carsShareCompareRsiOrgidList?.length) || 
                                        (account?.carsShareCompareRsiSiteidList?.includes(items?.siteId?.toString() || '') || account?.carsShareCompareRsiOrgidList?.includes(items?.organizationId?.toString() || ''))));

  if (!isCarsShareCompareEnabled) {
    tabs = tabs.filter(tab => tab.key !== CARS_KEY);
  }

  const buttonTextColor = account?.buttonTextColor;
  const buttonBorder = account?.buttonBorder;
  const buttonBorderRadius = account?.buttonBorderRadius;
  const buttonColor = account?.buttonColor;

  const styleButtonBorderRadius = !isEmpty(buttonBorderRadius) ? { borderRadius: `${buttonBorderRadius}px` } : {};  
  const styleButtonBorder = !isEmpty(buttonBorder)? { ...styleButtonBorderRadius, border: buttonBorder } : { ...styleButtonBorderRadius };  
  const styleButtonColor = !isEmpty(buttonTextColor)? { ...styleButtonBorder, color: buttonTextColor } : { ...styleButtonBorder };  
  const styleButton = !isEmpty(buttonColor)? { ...styleButtonColor, background: buttonColor } : { ...styleButtonColor };  

  return (
    <div className={`quotes-wrapper ${isMobile ? 'mobile' : ''}`}>
      <div className="quotes-wrapper__refresh" onClick={handleOnRefresh}>
        <div className="action-button" style={styleButton}>
          <FontAwesomeIcon icon={faSyncAlt} size="1x"/>
          <span>Refresh</span>
        </div>
      </div>

      <Tabs defaultActiveKey={HOTELS_KEY}>
        {tabs.map(({ title, columns, datasource, key }) => (
          <Tabs.TabPane key={key} tab={<FormattedMessage id={title} />}>
            <SearchTable
              title={NULL_VALUE}
              loading={loading}
              actions={NULL_VALUE}
              allColumns={columns as IColumnMenu[]}
              dataSource={datasource}
              pagination={{
                showSizeChanger: false,
                showQuickJumper: false
              }}
              filters={NULL_VALUE}
              totalOrderCount={datasource.length}
              rowKey={(row: any) => row.key ? `${row.key}` : `${row.quoteBase}`}
              hideRefresh={true}
              isFilterApplied={false}
              onFiltersChange={NULL_VALUE}
              onTableChange={NULL_VALUE}
              onResetFilters={NULL_VALUE}
              onApplyFilters={NULL_VALUE}
              onRefresh={handleOnRefresh}
            ></SearchTable>
          </Tabs.TabPane>
        ))}
      </Tabs>

      {(quotesHotels.length || quotesHistorical.length) ? <QuoteModalCompare visible={visibleHotels} quoteBase={quoteBase as string} onCancel={() => { setVisibleHotels(false); setQuoteBase(null) }} /> : null}
      {(quotesCondos.length || quotesHistorical.length) ? <QuoteCondosModalCompare visible={visibleCondos} quoteBase={quoteBase as string} onCancel={() => { setVisibleCondos(false); setQuoteBase(null) }} /> : null}
      {(quotesCars.length || quotesHistorical.length) ? <QuoteCarModalCompare visible={visibleCars} quoteBase={quoteBase as string} onCancel={() => { setVisibleCars(false); setQuoteBase(null) }} /> : null}  
    </div>

  );
}
